import { useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import { supabase } from "./lib/supabase";
import { useCoursesStore } from "./store/coursesStore";
import { courses as mockCourses } from "./mocks/courses";
import { logger } from "./utils/logger";

function AppInitializer() {
  const { setCourses, setLoading, isLoaded } = useCoursesStore();

  useEffect(() => {
    if (isLoaded) return;

    const fetchCourses = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('courses')
          .select('*')
          .order('sort_order', { ascending: true });

        if (error) throw error;

        if (data && data.length > 0) {
          const transformedCourses = data.map((item: any) => ({
            id: item.id,
            title: item.title,
            description: item.description,
            detailedDescription: item.detailed_description || '',
            image: item.image,
            category: item.category,
            badge: item.badge || '',
            price: item.price,
            discountPrice: item.discount_price ?? 0,
            installments: item.installments ?? 6,
            duration: item.duration,
            level: item.level,
            students: item.students ?? 0,
            rating: item.rating ?? 5.0,
            active: item.active ?? true,
            type: item.type ?? 'curso',
            content: item.content || [],
            benefits: item.benefits || [],
            requirements: item.requirements || [],
            faq: item.faq || [],
            syllabus: item.syllabus || [],
            certificate: item.certificate || { title: '', description: '', features: [] },
            whatsappNumber: item.whatsapp_number || '',
            dates: item.dates || [],
            syllabusPdfUrl: item.syllabus_pdf_url || '',
          }));
          setCourses(transformedCourses);
        } else {
          setCourses(mockCourses);
        }
      } catch (err) {
        logger.warn('No se pudo conectar a Supabase, usando datos de ejemplo:', err);
        setCourses(mockCourses);
      }
    };

    fetchCourses();
  }, [isLoaded, setCourses, setLoading]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppInitializer />
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;